import { useEffect, useState } from 'react'
import { IconButton, useTheme } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

import { ModalWrapper } from 'src/components'
import { IAccountUserStep } from 'src/types'
import { StepsModal } from '../associations-modal/steps-modal.component'

import useStyles from './styles'

export interface ISelectedIcon {
  icon: string
  text: string
  id: string
  subText?: string
  locationName?: string
}

interface Props {
  selectedSteps: IAccountUserStep[]
  scanerId: string
}

const ScannerStepsConnection = ({ selectedSteps, scanerId }: Props) => {
  const [open, setOpen] = useState(false)
  const [steps, setSteps] = useState<string[]>([])

  useEffect(() => {
    setSteps(selectedSteps.map((step) => step.id))
  }, [selectedSteps, open])

  const theme = useTheme()
  const classes = useStyles({})

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  const handleSelectedStep = (id: string) => {
    !!steps.find((stepId) => stepId === id)
      ? setSteps([...steps.filter((stepId) => stepId !== id)])
      : setSteps([...steps, id])

    return !!steps.find((stepId) => stepId === id)
    ? [...steps.filter((stepId) => stepId !== id)]
    : [...steps, id]
  }

  return (
    <>
      <IconButton
        onClick={handleOpenModal}
        sx={{
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          color: theme.palette.custom.grey3,
          padding: 0,
          ml: '-8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
      <ModalWrapper open={open} onClose={handleCloseModal} className={classes.paper}>
        <StepsModal selectedItems={steps} handleSelectItem={handleSelectedStep} showAccountInfo scanerId={scanerId} />
      </ModalWrapper>
    </>
  )
}

export { ScannerStepsConnection }
